var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "attachment_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E30613",
    d: "M273.5 487.9l3.3 3.3c-1.1-1.2-2.2-2.3-3.3-3.3zM231.3 537.6l-4.6-4.7c1.3 1.7 2.9 3.3 4.6 4.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M284.6 512.4c0-8.1-3-15.5-7.8-21.2l-3.3-3.3c-5.7-5-13.2-8.1-21.5-8.1-18 0-32.6 14.6-32.6 32.6 0 7.8 2.7 14.9 7.3 20.5l4.6 4.7c5.6 4.7 12.9 7.5 20.7 7.5 18-.1 32.6-14.7 32.6-32.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9AF17",
    d: "M869.2 453.1L493.6 77.5c-24.3-24.3-52.7-43.1-84.3-55.9C378.7 9.2 346.4 3 313.3 3s-65.5 6.3-96 18.6c-31.7 12.8-60 31.6-84.3 55.9-24.3 24.3-43.1 52.7-55.9 84.3-12.4 30.6-18.6 62.9-18.6 96s6.3 65.4 18.6 96c12.8 31.6 31.6 60 55.9 84.3l26.9 27.2 4.5 4.5c5.6 4.7 12.9 7.5 20.8 7.5 18 0 32.6-14.6 32.6-32.6 0-8-2.9-15.4-7.7-21.1l-3.5-3.5-27.6-27.9c-74.1-74.1-74.1-194.7 0-268.8 17.5-17.5 38.4-31.1 62.2-40.4 22.9-8.9 47.2-13.5 72.3-13.5S362.9 74 385.8 83c23.7 9.3 44.7 22.9 62.2 40.4L823.3 499c6.1 6.1 14.3 9.5 23 9.5s16.8-3.4 23-9.5c12.6-12.7 12.6-33.3-.1-45.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M298.8 605.8l-5.2-5.3c1.5 2 3.2 3.8 5.2 5.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M952.5 772.4c-9-22.5-22.3-42.6-39.4-59.6L409.7 203.4c-19.2-19.2-46.7-30.2-75.4-30.2-28.7 0-56.2 11-75.4 30.2-20.1 20.1-31.2 46.9-31.2 75.4 0 28.5 11.1 55.3 31.2 75.4l482.5 488.4c6.1 6.1 14.3 9.5 23 9.5s16.8-3.4 23-9.5c11.2-11.2 11.2-34.8 0-45.9L304.8 308.3c-16.3-16.3-16.3-42.7 0-59 7.5-7.5 18.2-11.8 29.5-11.8s22 4.3 29.5 11.8l503.5 509.4c45.2 45.2 45.2 118.7 0 163.9-10.7 10.7-23.4 18.9-37.9 24.6-13.9 5.5-28.8 8.2-44.1 8.2s-30.1-2.8-44.1-8.2c-14.5-5.7-27.2-13.9-37.9-24.6l-360-364-2.1-2.1c-5.8-5.4-13.6-8.7-22.1-8.7-18 0-32.6 14.6-32.6 32.6 0 7.6 2.6 14.6 7 20.1l5.2 5.3 358.6 362.7c33.9 33.9 79.3 52.6 127.9 52.6 48.6 0 94-18.7 127.9-52.6 17.1-17.1 30.3-37.2 39.4-59.6 8.7-21.7 13.1-44.6 13.1-68.2s-4.4-46.6-13.1-68.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default ForwardRef;